export const state = () => ({ continuationToken: null })

export const mutations = {
  setContinuationToken(state, value) {
    state.continuationToken = value
  }
}

export const actions = {
  async getData({ dispatch, commit }) {
    const data = await this.$apiAaltra.alertConfiguration()
    commit('setContinuationToken', data.continuation)
    return data
  },

  async saveData({ dispatch, commit }, { alertSettings }) {
    // Hide Tumble dryer and Toaster
    if (alertSettings.length) {
      alertSettings.forEach((item, itemIdx) => {
        if (item.id === 43 || item.id === 28) {
          alertSettings.splice(itemIdx, 1)
        }
      })
    }

    const data = alertSettings.map((a) => {
      return {
        applianceId: a.id,
        alertDetected: a._alertEnabled
      }
    })

    await this.$apiAaltra.updateAlertConfiguration(data)
  }
}
